import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  StateStoring,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarParametroIptuDs } from "../../DataSources";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroParamIptuGridState";

export default class ParametrosIptuBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.parametrosIptuDs = criarParametroIptuDs();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("parametrosiptu/editar/" + e.data.id);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="PARÂMETROS DE IPTU" novoCb={this.novoRegistro.bind(this)}>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.parametrosIptuDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            onEditingStart={this.onAtualizandoRow}
          >
            <StateStoring
              enabled={true}
              type={"localStorage"}
              storageKey={localStorageKey}
            />
            <Editing allowDeleting={true} allowUpdating={true} mode />
            <Editing allowDeleting={true} allowUpdating={true} mode />
            <Column dataField={"id"} visible={false} />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}>
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              dataField={"sequencial"}
              caption={"#"}
              width={"80px"}
              alignment={"center"}/>
            <Column dataField={"ano"} caption={"Ano"} width={"150px"} />
            <Column dataField={"mensagem"} caption={"Mensagem"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("parametrosIptu/novo");
  }
}
